<script lang="ts">
  import { pwa } from '../pwa.svelte';
</script>

{#if !pwa.online}
  <div class="bar" role="status">Offline — showing your last sync</div>
{/if}

<style>
  .bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 65;
    background: var(--ink);
    color: var(--cream);
    text-align: center;
    padding: 5px 12px;
    font-family: var(--mono);
    font-size: 10px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding-top: max(5px, env(safe-area-inset-top));
  }
  @media (min-width: 900px) {
    .bar {
      left: 84px;
    }
  }
</style>
